'use client';

import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Link, usePathname } from '@/navigation';
import { languages, languageLabels, LangCodeByCountry } from '@/shared/config/common/constants/lang';
import { classNames } from '@/shared/lib/classnames/classnames';
import { getHrefLang } from '../../utils/getHrefLang';
export const MobileLanguageSelector: React.FC = () => {
  const currentLocale = useLocale();
  const t = useTranslations();
  const pathname = usePathname();
  return <div className="inline-flex items-center rounded-full bg-gray-100 p-1 lg:hidden" role="group" aria-label={t('doctor.language_selector.aria_label_group')} data-sentry-component="MobileLanguageSelector" data-sentry-source-file="MobileLanguageSelector.tsx">
      {languages.map(lang => {
      const isSelected = currentLocale === lang.code;
      return <Link key={lang.code} className={classNames('rounded-full px-3 py-1 text-sm transition-colors', {
        'bg-white': isSelected,
        'hover:bg-gray-200': !isSelected
      })} href={getHrefLang(lang.code, pathname)} hrefLang={LangCodeByCountry[lang.code]} aria-current={isSelected ? 'page' : false} role="radio" aria-checked={isSelected} aria-label={t('doctor.language_selector.aria_label_option', {
        language: languageLabels[lang.code]
      })}>
            {lang.label}
          </Link>;
    })}
    </div>;
};